var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBinance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 53,
    viewBox: "0 0 54 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8968 22.2713L27.1148 11.9789L37.3383 22.2767L43.2839 16.2877L27.1148 0L10.9512 16.2822L16.8968 22.2713Z",
    fill: "#F3BA2F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6974 26.4987L6.75195 20.5098L0.806182 26.499L6.75166 32.4879L12.6974 26.4987Z",
    fill: "#F3BA2F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8957 30.7287L27.1138 41.021L37.3368 30.7236L43.2857 36.7093L43.2828 36.7127L27.1138 52.9999L10.9497 36.7181L10.9414 36.7097L16.8957 30.7287Z",
    fill: "#F3BA2F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4761 32.4922L53.4219 26.5029L47.4764 20.514L41.5306 26.5032L47.4761 32.4922Z",
    fill: "#F3BA2F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.147 26.4973H33.1495L27.1163 20.4199L22.6576 24.9112H22.6572L22.1452 25.4273L21.0884 26.4918L21.0801 26.5002L21.0884 26.509L27.1163 32.5809L33.1495 26.5036L33.1524 26.5002L33.147 26.4973Z",
    fill: "#F3BA2F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBinance);
export default __webpack_public_path__ + "static/media/binance.34721973f3dde2e860a94a7a935b4cc6.svg";
export { ForwardRef as ReactComponent };